package blazern.lexisoup.core.ui.components

@androidx.compose.runtime.Composable
actual fun ClearSearchFocusOnBack(enabled: Boolean, onFocusCleared: ()->Unit) {
    // Nothing
}
